import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ticket, TicketManualUpdateModel } from '@app/modules/customer/models';
import { AppState } from '@app/reducers';
import { ACCEPTABLE_ALL_MAJOR_FILE_EXTENSIONS, CrudType, currentComponentPageBasedPermissionsSelector$, defaultPopupType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, prepareGetRequestHttpParams, prepareRequiredHttpParams, QuickActionType, ResponseMessageTypes, setRequiredValidator, sidebarDataSelector$, WRONG_FILE_EXTENSION_SELECTION_ERROR, fileUrlDownload } from '@app/shared';
import { CrudService, RxjsService, SnackbarService } from '@app/shared/services';
import { AlterContactDialogComponent, CustomerTicketAddEditComponent } from '@modules/customer/components';
import { CustomerManagementService } from '@modules/customer/services/customermanagement.services';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management';
import { loggedInUserData } from '@modules/others';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared';
import { UserModuleApiSuffixModels } from '@modules/user/shared';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest, forkJoin } from 'rxjs';
import { SendEmailComponent } from './email-sms-modal/email-modal.component';
import { SendSMSModalComponent } from './email-sms-modal/sms-modal.component';
@Component({
  selector: 'app-customer-ticket-view',
  templateUrl: './customer-ticket-view.component.html',
  styleUrls: ['./customer-ticket.scss']
})
export class CustomerTicketViewComponent implements OnInit {
  @ViewChild('fileInput', null) myFileInputField: ElementRef;
  @Input() typeInNumber;
  formData = new FormData();
  ticketViewForm: FormGroup;
  ticketStatusList = [];
  ticketGroupList = [];
  assigntoList = [];
  ticketId: string;
  ticketdetails;
  pastcomments = [];
  ticketDto: ticket | any;
  groupId: string;
  customerId: string;
  fileName: string;
  ticketGroupId: string;
  listOfFiles: any[] = [];
  documentdetails: Array<any> = [];
  addressId;
  documentDetails;
  isViewMore: boolean;
  alterContactSubscription;
  fileList: File[] = [];
  maxFilesUpload: Number = 5;
  customerDetails;
  pagePermissions = []
  actionTabList = {
    enableHeader: true,
    columns: [
      { id: 0, field: 'edit', displayName: 'Update Ticket', isSelected: false },
      { id: 1, field: 'view alter contact', displayName: 'View Alternate Contact', isSelected: false },
      { id: 2, field: 'email', displayName: 'Email', isSelected: false },
      { id: 3, field: 'sms', displayName: 'SMS', isSelected: false },
    ]
  };
  loggedInUserData: LoggedInUserModel;
  isSuspendTicket = false;
  serviceSuspendId = '';
  isLoading: boolean;
  fromComponent: string;
  stopAndKnockDialog = false;
  defaultPopupType = defaultPopupType.P_DIALOG;
  relocationMapDetails: any;
  selectedAccountCode: string;
  previousAddresses: any[] = [];
  selectedPreviousAddressId: string;
  selectedDecoders: any[] = [];
  private _flattenedDecoders: any[] = [];
  private selectedDecoderIds = new Set<string>();
  showConfirmationDialog = false;

  /**
   * Generates a unique key from decoderId, accountCode, and setNameId
   * This ensures uniqueness is based on the combination of all three properties
   */
  private generateUniqueDecoderKey(decoderId: string, accountCode: string, setNameId: string): string {
    return `${decoderId}|${accountCode}|${setNameId || ''}`;
  }

  private updateFlattenedDecoders(): void {
    if (!this.relocationMapDetails?.accounts) {
      this._flattenedDecoders = [];
      return;
    }

    this._flattenedDecoders = [];
    this.relocationMapDetails.accounts.forEach(account => {
      if (account.decoders && account.decoders.length > 0) {
        account.decoders.forEach(decoder => {
          const uniqueKey = this.generateUniqueDecoderKey(decoder.decoderId, account.accountCode, decoder.setNameId);
          this._flattenedDecoders.push({
            ...decoder,
            accountCode: account.accountCode,
            oldCustomerID: this.relocationMapDetails?.oldCustomerRefNo,
            newCustomerID: this.relocationMapDetails?.newCustomerRefNo,
            isSelected: this.selectedDecoderIds.has(uniqueKey)
          });
        });
      }
    });
  }

  constructor(private activatedRoute: ActivatedRoute, private rxjsService: RxjsService,
    private store: Store<AppState>, private formBuilder: FormBuilder, private snackbarService: SnackbarService, private dialogService: DialogService,
    private httpService: CrudService, private router: Router,
    private customerManagementService: CustomerManagementService) {
  }

  ngOnInit() {
    this.combineLatestNgrxStoreData();
    this.getForkJoinRequests();
    this.ticketDto = new ticket();
    this.createTicketManualAddForm();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData), this.activatedRoute.queryParams,
      this.store.select(currentComponentPageBasedPermissionsSelector$),
      this.store.select(sidebarDataSelector$),
    ]).subscribe((response: any) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let fromComponent = response[1]?.fromComponent;
      let permission;
      let customerTickets;
      let permissions;
      if (response[1]) {
        this.ticketId = response[1]?.id;
        this.ticketGroupId = response[1]?.ticketgroupid;
        this.customerId = response[1]?.customerId;
        this.isSuspendTicket = response[1].isSuspendTicket || false;
        this.addressId = response[1]?.addressId;
        this.serviceSuspendId = response[1]?.serviceSuspendId;
      }
      let customerManagemnt = response[3]?.['menuAccess'].find(item => item.menuName == "Customer Management");
      if (customerManagemnt) {
        let tickets = customerManagemnt['subMenu']?.find(item => item.menuName == "Tickets");
        permissions = tickets?.subMenu
      }

      let customersPermission = response[2]?.Customers
      if (customersPermission) {
        let customerManagement = customersPermission?.find(item => item.menuName == "Customer Dashboard")
        if (customerManagement) {
          customerTickets = customerManagement?.subMenu?.find(item => item.menuName == "TICKETING")['subMenu'];
        }
      }
      if (fromComponent == "Customer" || fromComponent == "Non Customers") {
        permission = customerTickets;
      } else {
        permission = response[2][fromComponent]
      }
      if (!permission) {
        permission = permissions;
      }
      this.pagePermissions = permission?.find(item => item.menuName == "Quick Action")

    });
  }

  getForkJoinRequests(): void {
    forkJoin([
      this.httpService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UX_TICKETSTATUS, undefined, true, null),
      this.httpService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_GROUPS, undefined, true),
      this.customerManagementService.getCustomer(this.customerId),
      this.getTicketIDApi(),
    ])
      .subscribe((response: IApplicationResponse[]) => {
        response.forEach((respObj: IApplicationResponse, ix: number) => {
          if (respObj.isSuccess && respObj.statusCode == 200 && respObj.resources) {
            switch (ix) {
              case 0:
                this.ticketStatusList = respObj.resources;
                break;
              case 1:
                this.ticketGroupList = respObj.resources;
                break;
              case 2:
                this.customerDetails = respObj.resources;
                let _mobile = this.customerDetails?.mobileNumber1.split(" ");
                this.customerDetails.mobileCode = _mobile[0];
                this.customerDetails.mobileNumber = _mobile[1];
                this.addressId = this.addressId ? this.addressId : this.customerDetails?.addresses.length ? this.customerDetails?.addresses[0]?.addressId : "";
                break;
              case 3:
                this.onPatchValue(respObj);
                break;
            }
          }
          if (ix == response.length - 1 && !respObj.resources) {
            this.isLoading = false;
          }
        });
      });
  }

  createTicketManualAddForm(TicketModelData?: TicketManualUpdateModel): void {
    let ticketModel = new TicketManualUpdateModel(TicketModelData);
    this.ticketViewForm = this.formBuilder.group({});
    Object.keys(ticketModel).forEach((key) => {
      this.ticketViewForm.addControl(key, new FormControl(TicketManualUpdateModel[key]));
    });
    this.ticketViewForm = setRequiredValidator(this.ticketViewForm, ["ticketStatusId", "userGroupId", "assignedTo", "description"]);
  }

  OnUserGroupChange(event) {
    this.groupId = event.target.value;
    this.getassignedto(this.groupId);
  }

  getassignedto(id: string) {
    if (id) {
      this.rxjsService.setGlobalLoaderProperty(true);
      this.httpService.dropdown(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_ASSINGNTO, prepareGetRequestHttpParams(null, null, { groupId: id })).subscribe((response) => {
        if (response.statusCode == 200) {
          this.assigntoList = response.resources;
        }
        this.isLoading = false;
      });
    }
  }

  onQuickActionClick(e) {
    this.onQuickRequested(e?.type, e.index);
  }

  onCRUDRequested(type: CrudType | string, row?: object): void {
    switch (type) {
      case CrudType.EDIT:
        this.Edit();
        break;
    }
  }

  onQuickRequested(type: QuickActionType | string, row?: object): void {
    switch (type) {
      case 'map sok address':
      case 'relocation':
      case 'map relocation':
        this.openRelocationMapDialog();
        break;
      case QuickActionType.EDIT:
        if (this.getPermissionByActionType("Update Ticket")) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.Edit();
        break;
      case QuickActionType.VIEW_ALTER_CONTACT:
        if (this.getPermissionByActionType("View Alternate Contact")) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.alterContact();
        break;
      case QuickActionType.PROCESS_CANEL:
        if (this.getPermissionByActionType("Process Cancellation")) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        if (this.ticketDto?.serviceCancellationId) {
          this.router.navigate(['/customer/manage-customers/ticket/process-cancellation'], { queryParams: { id: this.ticketDto?.contractId, customerId: this.customerId, addressId: this.addressId, ticketId: this.ticketId, serviceCancellationId: this.ticketDto?.serviceCancellationId, subscriptionIds: JSON.stringify(this.ticketDto?.subscriptionIds) } });
        } else if (!this.ticketDto?.serviceCancellationId && this.ticketDto?.isCancellationLetterReceived && this.ticketDto?.ticketTypeName?.toLowerCase() == 'request for cancel') {
          this.router.navigate(['/customer/manage-customers/ticket/process-cancellation'], { queryParams: { customerId: this.customerId, addressId: this.addressId, ticketId: this.ticketId, subscriptionIds: JSON.stringify(this.ticketDto?.subscriptionIds) } });
        } else {
          this.snackbarService.openSnackbar('Process Cancellation shows only for Action type must be Request to Cancel and Cancellation Notice to be received', ResponseMessageTypes.WARNING);
        }
        break;
      case QuickActionType.EMAIL:
        if (this.getPermissionByActionType("Email")) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openModel(SendEmailComponent, 'Email');
        break;
      case QuickActionType.SMS:
        if (this.getPermissionByActionType("SMS")) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openModel(SendSMSModalComponent, 'Sms');
        break;
    }
  }

  openModel(component, type) {
    const titile = type?.toLowerCase() == 'sms' ? type?.toUpperCase() : type;
    const ref = this.dialogService.open(component, {
      showHeader: true,
      header: `Send ${titile}`,
      baseZIndex: 10000,
      width: '700px',
      data: {
        notificationTo: type == 'Email' ? this.customerDetails.email : Number(this.customerDetails.mobileNumber),
        notificationToCountryCode: this.customerDetails.mobileCode,
        referenceId: this.ticketId,
        customerId: this.customerId,
      },
    });
    ref.onClose.subscribe((result) => {
      if (result == true) {
        this.getTicketById();
      }
    });
  }

  Edit() {
    this.rxjsService.setDialogOpenProperty(true);
    const dialogReff = this.dialogService.open(CustomerTicketAddEditComponent, {
      baseZIndex: 1000,
      width: '750px', showHeader: false, data: {
        custId: this.customerId, ticketId: this.ticketId, isSuspendTicket: this.isSuspendTicket,
        addressId: this.addressId, serviceSuspendId: this.serviceSuspendId
      }
    });
    dialogReff.onClose.subscribe(result => {
      if (result) {
        this.getTicketById();
      }
    });
  }

  alterContact() {
    if (this.alterContactSubscription && !this.alterContactSubscription.closed) {
      this.alterContactSubscription.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.alterContactSubscription = this.httpService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKET_ALTERNATE_CONTACTS_DETAIL, null, false, prepareRequiredHttpParams({ customerId: this.customerId, siteAddressId: this.addressId }), 1)
      .subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode == 200) {
          const ref = this.dialogService.open(AlterContactDialogComponent, {
            header: 'View Alternate Contact - ' + this.ticketDto?.ticketRefNo,
            baseZIndex: 500,
            width: '800px',
            closable: false,
            showHeader: false,
            data: {
              result: response?.resources,
              customerId: this.customerId,
              userId: this.loggedInUserData.userId,
              addressId: this.addressId,
              ticketId: this.ticketId,
            },
          });
          ref.onClose.subscribe((res: IApplicationResponse) => {
            if (res?.isSuccess && res?.statusCode == 200) {

            }
          });
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  getTicketById(type?: string) {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.getTicketIDApi().subscribe((response: IApplicationResponse) => {
      if (response?.isSuccess && response?.statusCode == 200) {
        this.onPatchValue(response);
        if (type === 'mapping') {
          this.onUpdateTicket();
        }
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  getTicketIDApi() {
    return this.httpService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKETS, this.ticketId, false, null, 1);
  }

  onPatchValue(response) {
    this.ticketDto = response.resources;
    this.ticketdetails = response.resources;
    this.ticketViewForm.patchValue(response.resources);
    this.pastcomments = this.ticketdetails.pastcoments;
    this.addressId = response.resources?.siteAddressId;
    this.getassignedto(this.ticketdetails.userGroupId);
    this.showHideProcessCancellation();
    this.actionTabList['columns'].map(el => el.isSelected = false);
    if (!this.ticketdetails.userGroupId) {
      this.isLoading = false;
    }
  }



  uploadFiles(file) {
    if (file && file.length == 0)
      return;
    var numberOfFilesUploaded: Number = this.listOfFiles.length;
    if (file.length > this.maxFilesUpload || numberOfFilesUploaded >= this.maxFilesUpload) {
      this.snackbarService.openSnackbar(`You can upload maximum ${this.maxFilesUpload} files`, ResponseMessageTypes.WARNING);
      return;
    }
    for (let i = 0; i < file.length; i++) {
      let selectedFile = file[i];
      const path = selectedFile.name.split('.');
      const extension = path[path.length - 1];
      if (ACCEPTABLE_ALL_MAJOR_FILE_EXTENSIONS.includes(extension)) {
        let filename = this.fileList?.find(x => x.name === selectedFile.name);
        if (filename == undefined) {
          this.fileList.push(selectedFile);
          this.listOfFiles.push(selectedFile.name);
          this.ticketViewForm.markAllAsTouched();
          this.myFileInputField.nativeElement.value = null;
        }
      } else {
        this.snackbarService.openSnackbar(WRONG_FILE_EXTENSION_SELECTION_ERROR, ResponseMessageTypes.WARNING);
      }
    }
  }

  showHideProcessCancellation() {
    const isMoveRadio = this.ticketDto?.ticketTypeName?.toLowerCase() == 'moveradio';
    if (this.ticketDto?.ticketTypeName?.toLowerCase() == 'request for cancel') {
      this.actionTabList['columns'] = [
        ...(isMoveRadio ? [{ id: 0, field: 'map sok address', displayName: 'Ticket - SOK Mapping', isSelected: false }] : []),
        { id: isMoveRadio ? 1 : 0, field: 'edit', displayName: 'Update Ticket', isSelected: false },
        { id: isMoveRadio ? 2 : 1, field: 'process cancel', displayName: this.ticketDto?.serviceCancellationId ? 'View Process Cancellation' : 'Process Cancellation', isSelected: false },
        { id: isMoveRadio ? 3 : 2, field: 'view alter contact', displayName: 'View Alternate Contact', isSelected: false },
        { id: isMoveRadio ? 4 : 3, field: 'email', displayName: 'Email', isSelected: false },
        { id: isMoveRadio ? 5 : 4, field: 'sms', displayName: 'SMS', isSelected: false },
      ]
    } else {
      this.actionTabList['columns'] = [
        ...(isMoveRadio ? [{ id: 0, field: 'map sok address', displayName: 'Ticket - SOK Mapping', isSelected: false }] : []),
        { id: isMoveRadio ? 1 : 0, field: 'edit', displayName: 'Update Ticket', isSelected: false },
        { id: isMoveRadio ? 2 : 1, field: 'view alter contact', displayName: 'View Alternate Contact', isSelected: false },
        { id: isMoveRadio ? 3 : 2, field: 'email', displayName: 'Email', isSelected: false },
        { id: isMoveRadio ? 4 : 3, field: 'sms', displayName: 'SMS', isSelected: false },
      ]
    }
  }

  submitStopAndKnockQuickAction(): void {
    this.showConfirmationDialog = true;
  }

  onConfirmMapping(): void {
    this.showConfirmationDialog = false;
    this.submitMappingRequest();
  }

  onCancelConfirmation(): void {
    this.showConfirmationDialog = false;
  }

  private resetDialogState(): void {
    this.selectedDecoders = [];
    this._flattenedDecoders.map(decoder => decoder.isSelected = false);
    this.selectedDecoderIds.clear();
    this.showConfirmationDialog = false;
  }

  onCancelStopAndKnockDialog(): void {
    this.stopAndKnockDialog = false;
    this.resetDialogState();
  }

  private submitMappingRequest(): void {
    const selected = this.selectedDecoders ?? [];
    const decoders = selected.map(sel => {
      // find the account that matches selected.accountCode
      const account = this.relocationMapDetails?.accounts?.find(a => a.accountCode == sel.accountCode);
      if (!account) {
        // account missing — skip or return a minimal object depending on your needs
        return null;
      }

      // find the matching decoder using composite key: decoderId + accountCode + setNameId
      const found = account.decoders?.find(d =>
        d.decoderId === sel.decoderId &&
        d.setNameId === sel.setNameId
      );
      if (!found) {
        return null;
      }

      return {
        accountCode: account.accountCode,
        decoderId: found.decoderId,
        setNameId: found.setNameId,
        serialNo: found.serialNo,
        testDelay: found.testDelay,
        isAddNewRadio: found.isAddNewRadio,
        description: found.description,
        radioArea: found.radioArea,
        oldCustomerAccountId: found.customerAccountId,
        callInitiationId: found.callInitiationId
      };
    }).filter(Boolean); // removes nulls

    const payload = {
      customerId: this.relocationMapDetails?.newCustomerId,
      customerAddressId: this.relocationMapDetails?.customerAddressId,
      createdUserId: this.loggedInUserData.userId,
      decoders
    };

    this.rxjsService.setPopupLoaderProperty(true);
    this.httpService.create(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.CUSTOMER_ACCOUNT_RELOCATION, payload)
      .subscribe((response: IApplicationResponse) => {
        if (response?.isSuccess && response?.statusCode === 200) {
          this.snackbarService.openSnackbar('Radio mapping completed successfully', ResponseMessageTypes.SUCCESS);
          this.stopAndKnockDialog = false;
          this.resetDialogState();
          // Optionally refresh data
          this.getTicketById('mapping');
        } else {
          this.snackbarService.openSnackbar(response?.message || 'Failed to complete radio mapping', ResponseMessageTypes.ERROR);
        }
      }, (error) => {
        this.snackbarService.openSnackbar('Failed to complete radio mapping', ResponseMessageTypes.ERROR);
      }, () => {
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  get flattenedDecoders(): any[] {
    return this._flattenedDecoders;
  }

  onDecoderSelectionChange(decoder: any, event: any): void {
    const uniqueKey = this.generateUniqueDecoderKey(decoder.decoderId, decoder.accountCode, decoder.setNameId);

    if (event.target.checked) {
      if (!this.selectedDecoderIds.has(uniqueKey)) {
        this.selectedDecoders.push(decoder);
        this.selectedDecoderIds.add(uniqueKey);
      }
    } else {
      // Filter using the composite key to ensure we remove the correct decoder
      this.selectedDecoders = this.selectedDecoders.filter(selected => {
        const selectedKey = this.generateUniqueDecoderKey(selected.decoderId, selected.accountCode, selected.setNameId);
        return selectedKey !== uniqueKey;
      });
      this.selectedDecoderIds.delete(uniqueKey);
    }
  }

  get isBtnEnabled(): boolean {
    return this.selectedDecoders && this.selectedDecoders.length > 0 && this.relocationMapDetails?.isMoveRadioEnabled;
  }

  get selectedRadioTypes(): string {
    return this.selectedDecoders?.map(d => d.decoderType).join(', ') || '';
  }


  private openRelocationMapDialog(): void {
    this.stopAndKnockDialog = true;
    this.rxjsService.setDialogOpenProperty(true);
    this.rxjsService.setPopupLoaderProperty(true);
    // prepare previous addresses
    this.previousAddresses = this.customerDetails?.addresses || [];
    this.selectedPreviousAddressId = this.previousAddresses.length ? this.previousAddresses[0]?.addressId : null;
    this.loadRelocationMappingDetails(this.selectedPreviousAddressId);
  }

  onPreviousAddressChange(addressId: string): void {
    this.selectedPreviousAddressId = addressId;
    this.rxjsService.setPopupLoaderProperty(true);
    this.loadRelocationMappingDetails(addressId);
  }

  private loadRelocationMappingDetails(addressId?: string): void {
    this.httpService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.RELOCATION_MAPPING_DETAILS, undefined, false,
      prepareRequiredHttpParams({ ticketId: this.ticketId, addressId: this.ticketDto?.siteAddressId })).subscribe((response: IApplicationResponse) => {
        if (response?.isSuccess && response?.statusCode === 200) {
          this.relocationMapDetails = response.resources;
          this.updateFlattenedDecoders();
        } else {
          this.snackbarService.openSnackbar(response?.message || 'Failed to load relocation mapping details', ResponseMessageTypes.ERROR);
        }
      }, () => {
        this.snackbarService.openSnackbar('Failed to load relocation mapping details', ResponseMessageTypes.ERROR);
      }, () => {
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  removeSelectedFile(index) {
    this.listOfFiles.splice(index, 1);
    this.fileList.splice(index, 1);
  }

  onUpdateTicket(): void {
    const payload = {
      ...this.ticketDto,
      ticketStatusId: 5
    }
    let formData = new FormData();
    formData.append('ticket', JSON.stringify(payload));
    this.httpService.update(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKETS, formData).subscribe((response) => {
      if (response.statusCode == 200 && response.isSuccess) {
        //this.redirect();
        this.getTicketById();
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  showOutcome() {
    return this.ticketDto?.ticketStatusName?.toLowerCase() == 'completed';
  }

  onCancel(): void {
    let selectedTabIndex = 0;
    if (this.ticketGroupId === "1") {
      selectedTabIndex = 2;
    }
    else if (this.ticketGroupId === "2") {
      selectedTabIndex = 1;
    }
    else {
      selectedTabIndex = 7;
    }
    this.rxjsService.setViewCustomerData({
      customerId: this.customerId,
      addressId: this.addressId,
      customerTab: selectedTabIndex,
      monitoringTab: null,
    })
    this.rxjsService.navigateToViewCustomerPage();
  }

  onShowViewPage(e) {
    this.isViewMore = e;
  }

  getHeight() {
    return this.isViewMore ? '25vh' : '41vh';
  }

  showOutCome() {
    return this.ticketDto?.status?.toLowerCase() == 'completed';
  }

  showReqCancel() {
    return this.ticketDto?.ticketTypeName?.toLowerCase() == 'request for cancel';
  }

  redirect() {
    let selectedTabIndex = 0;
    if (this.ticketGroupId == "1") {
      selectedTabIndex = 6;
    }
    else if (this.ticketGroupId == "2") {
      selectedTabIndex = 5;
    }
    else {
      selectedTabIndex = 10;
    }
    this.rxjsService.setViewCustomerData({
      customerId: this.customerId,
      addressId: this.addressId,
      customerTab: selectedTabIndex,
      monitoringTab: null,
    })
    this.rxjsService.navigateToViewCustomerPage();
  }

  getPermissionByActionType(actionTypeMenuName): boolean {
    let foundObj = this.pagePermissions?.['subMenu']?.find(fSC => fSC.menuName == actionTypeMenuName);
    if (foundObj) {
      return false;
    }
    else {
      return true;
    }
  }

  getFileName(filePath: string): string {
    if (!filePath) return 'download';
    const pathOnly = filePath.split('?')[0];
    return pathOnly.split('/').pop() || pathOnly.split('\\').pop() || 'download';
  }

  downloadDocument(documentPath: string, documentName?: string, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (documentPath) {
      const fileName = documentName && documentName.trim() ? documentName.trim() : this.getFileName(documentPath);
      fileUrlDownload(
        documentPath,
        fileName,
        false,
        this.httpService,
        this.rxjsService,
        true,
        'preview'
      ).catch(error => {
        console.error('Error opening document:', error);
        this.snackbarService.openSnackbar('Unable to open document', ResponseMessageTypes.ERROR);
      });
    }
  }
}